import React from 'react';
import ProductPendingSummary from './ProductPendingSummary';

const ProductPendingList = ({products}) => {
    return(
        <div>
            <ul className="list-group">
                {products && products.map(product => {
                    return (
                        <div key={product.objectID}>
                            <ProductPendingSummary product={product}/>
                        </div>  
                    )
                })}
            </ul>
        </div> 
    )
}

export default ProductPendingList;